var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.775 7.84062L7.30625 8.37187L7.8375 7.84062L14.0875 1.59063L14.6187 1.05938L13.5594 0L13.0281 0.53125L7.30938 6.25L1.59062 0.53125L1.05937 0L0 1.05938L0.53125 1.59063L6.78125 7.84062H6.775ZM6.775 13.8406L7.30625 14.3719L7.8375 13.8406L14.0875 7.59062L14.6187 7.05937L13.5594 6L13.0281 6.53125L7.30938 12.25L1.59062 6.53125L1.05937 6L0 7.05937L0.53125 7.59062L6.78125 13.8406H6.775Z",
    fill: "#1D1F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowVertical);
export default __webpack_public_path__ + "static/media/double-arrow-vertical.b3042741590dcd770facb802360d9a3a.svg";
export { ForwardRef as ReactComponent };